import script from "./StatusTag.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusTag.vue?vue&type=script&setup=true&lang=js"

import "./StatusTag.vue?vue&type=style&index=0&id=bb6c39fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb6c39fa"]])

export default __exports__